import * as types from './LoginActionTypes.js';

const initialState = {
    loginState: false,
    userid: null,
    userName: '',
    email: '',
    lastName: '',
    companyIds: [],
    auth: {},
    filters: {},
    userToken: null,
    subscriberUniqueId: null,
    isSubscriberAdmin: false,
    isFlagstoneAdmin: false,
    userRoles: [],
    roleIds: [],
};

export default function Login(state = initialState, action) {
    switch (action.type) {
        case types.SET_LOGIN:
            if (action.payload !== state.loginState) {
                return Object.assign({}, state, { loginState: action.payload });
            }
            return state;
        case types.SET_USERID:
            if (action.payload !== state.userid) {
                return Object.assign({}, state, { userid: action.payload });
            }
            return state;
        case types.SET_USERNAME:
            if (action.payload !== state.userName) {
                return Object.assign({}, state, { userName: action.payload });
            }
            return state;
        case types.SET_EMAIL:
            if (action.payload !== state.email) {
                return Object.assign({}, state, { email: action.payload });
            }
            return state;
        case types.SET_LASTNAME:
            if (action.payload !== state.lastName) {
                return Object.assign({}, state, { lastName: action.payload });
            }
            return state;
        case types.SET_COMPANYIDS:
            if (action.payload !== state.companyIds) {
                return Object.assign({}, state, { companyIds: action.payload });
            }
            return state;
        case types.SET_USERTOKEN:
            if (action.payload !== state.userToken) {
                return Object.assign({}, state, { userToken: action.payload });
            }
            return state;
        case types.SET_USERROLES:
            if (action.payload !== state.userRoles) {
                return Object.assign({}, state, { userRoles: action.payload });
            }
            return state;
        case types.SET_SUBSCRIBERUNIQUEID:
            if (action.payload !== state.subscriberUniqueId) {
                return Object.assign({}, state, { subscriberUniqueId: action.payload });
            }
            return state;
        case types.SET_ISSUBSCRIBERADMIN:
            if (action.payload !== state.isSubscriberAdmin) {
                return Object.assign({}, state, { isSubscriberAdmin: action.payload });
            }
            return state;
        case types.SET_ISFLAGSTONEADMIN:
            if (action.payload !== state.isFlagstoneAdmin) {
                return Object.assign({}, state, { isFlagstoneAdmin: action.payload });
            }
            return state;
        case types.LOGOUT:
            return { ...initialState };

        default: {
            return state;
        }
    }
}